// extracted by mini-css-extract-plugin
export var dropdownButton = "_2m-0";
export var fullWidthDropdownButton = "_2m-1";
export var icon = "_2m-3";
export var iconPlaceholder = "_2m-2";
export var menuItemRow = "_2m-9";
export var separator = "_2m-e";
export var shortcutContainer = "_2m-7";
export var shortcutContainerFilled = "_2m-8";
export var shortcutIconLg = "_2m-6";
export var shortcutIconMd = "_2m-5";
export var shortcutIconSm = "_2m-4";
export var submenuChevron = "_2m-d";
export var submenuDropdown = "_2m-a";
export var submenuTriggerRow = "_2m-b";
export var submenuTriggerRowOpen = "_2m-c";